import { ChevronUp, ChevronDown } from "react-feather";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Table,
} from "reactstrap";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { taxData } from "../../../data/tax-type/TaxType";
import { P } from "../../../AbstractElements";
import NavigationBreadcrumbs from "../../../common-elements/breadcrumbs/NavigationBreadcrumbs";
 
function TaxListCountryHistoryData() {
  const { t } = useTranslation();
  const { countryName } = useParams();
  const [open, setOpen] = useState<string>("1");

  const toggle = (id: string) => {
    setOpen(open === id ? "" : id);
  };

  const normalizedCountryName = countryName?.replace(/%20/g, " ") || "India";
  const countryTaxes =
    taxData[normalizedCountryName as keyof typeof taxData] || taxData.India;

  const renderTaxTypeAccordions = (taxType: string, taxArray: any[]) =>
    taxArray?.map((taxPeriod, idx) => (
      <AccordionItem key={`${taxType}-${idx}`}>
        <AccordionHeader
          targetId={`${taxType}-${idx}`}
          className="d-flex justify-content-between align-items-center w-100 bg-light"
        >
          <div className="d-flex align-items-center text-dark">
            <h5 className="mb-0 text-capitalize" style={{ minWidth: "160px" }}>
              {taxType}
            </h5>
          </div>
          <div className="d-flex align-items-center ml-auto">
            <em className="text-muted">
              Effective From: {taxPeriod.applicableDate.effectiveFrom}
            </em>
            <span className="mx-3"></span>
            <em className="text-muted">
              Effective To: {taxPeriod.applicableDate.effectiveTo}
            </em>
          </div>
          {!taxPeriod.static && (
            open === `${taxType}-${idx}` ? (
              <ChevronUp
                className="svg-color"
                size={20}
                style={{ color: "var(--theme-default, #6c757d)" }}
              />
            ) : (
              <ChevronDown
                className="svg-color"
                size={20}
                style={{ color: "var(--theme-default, #6c757d)" }}
              />
            )
          )}
        </AccordionHeader>
        <AccordionBody accordionId={`${taxType}-${idx}`}>
          {taxPeriod.data && (
            <Table responsive className="mb-0">
              <thead>
                <tr>
                  {taxPeriod.headers?.map((header: string, i: number) => (
                    <th scope="col" key={i}>
                      {header}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {taxPeriod.data.map(
                  (row: { [key: string]: string }, i: number) => (
                    <tr key={i}>
                      {Object.values(row).map((value: string, j: number) => (
                        <td key={j}>{value}</td>
                      ))}
                    </tr>
                  )
                )}
              </tbody>
            </Table>
          )}
          {taxPeriod.static && (
            <P>
              {taxType} is a static tax type with no slabs. Details vary by
              state or regulation.
            </P>
          )}
        </AccordionBody>
      </AccordionItem>
    ));

    const breadcrumbLinks = [
      { label: "Tax Types", url: `${process.env.PUBLIC_URL}/masterdata/tax-types` },
      {
        label: t(normalizedCountryName),
        url: `${process.env.PUBLIC_URL}/tax-types/country/${encodeURIComponent(
          normalizedCountryName
        )}`,
      },
      { label: "History", active: true },
    ];
  return (
    <>
      <NavigationBreadcrumbs
        mainTitle={t("TaxTypes")}
        parent={t("Master Data")}
        links={breadcrumbLinks}
      />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <Container fluid>
                  <Row>
                    <Col xl="12" sm="12">
                      <Accordion open={open} toggle={toggle}>
                        {Object.keys(countryTaxes).map((taxType) =>
                          renderTaxTypeAccordions(
                            taxType,
                            countryTaxes[taxType]
                          )
                        )}
                      </Accordion>
                    </Col>
                  </Row>
                </Container>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default TaxListCountryHistoryData;